const API_BASE_URL = process.env.REACT_APP_PHP_API_BASE_URL;

export async function getCreativeLibraryProjects(pageData) {
	const response = await fetch(`${API_BASE_URL}/creative-library/getProjects/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
		// headers: {
		// 	'Content-Type': 'application/json'
		// },
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the creative library projects.');
	}

	const data = await response.json();

	// if (!data['success']) { // Manually created and returned attributes
	// 	throw new Error(data['status_code'] + ': ' + data['status']);
	// }
	// console.log('DATA');
	// console.log(data);
	return data;
}

export async function getCreativeLibraryAllItems(pageData) {
	const response = await fetch(`${API_BASE_URL}/creative-library/getAllItems/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
		// headers: {
		// 	'Content-Type': 'application/json'
		// },
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the latest creative library items.');
	}

	const data = await response.json();

	return data;
}

export async function getCreativeLibraryItems(pageData) {
	const response = await fetch(`${API_BASE_URL}/creative-library/getItems/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
		// headers: {
		// 	'Content-Type': 'application/json'
		// },
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the creative library items.');
	}

	const data = await response.json();

	// if (!data['success']) { // Manually created and returned attributes
	// 	throw new Error(data['status_code'] + ': ' + data['status']);
	// }
	// console.log('DATA');
	// console.log(data);
	return data;
}

export async function getCreativeLibraryItem(pageData) {
	const response = await fetch(`${API_BASE_URL}/creative-library/getItem/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not retrieve the creative library item.');
	}

	const data = await response.json();

	return data;
}

export async function createCreativeLibraryItem(pageData) {
	const response = await fetch(`${API_BASE_URL}/creative-library/createItem/`, {
		method: 'POST',
		body: pageData,
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not add the creative library item.');
	}

	const data = await response.json();

	return data;
}

export async function modifyCreativeLibraryItem(pageData) {
	const response = await fetch(`${API_BASE_URL}/creative-library/modifyItem/`, {
		method: 'POST',
		body: pageData,
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not modify the creative library item.');
	}

	const data = await response.json();

	return data;
}

export async function removeCreativeLibraryItem(pageData) {
	const response = await fetch(`${API_BASE_URL}/creative-library/removeItem/`, {
		method: 'POST',
		body: JSON.stringify(pageData),
		credentials: 'include'
	});

	if (!response.ok) {
		throw new Error(response.status + ': ' + response.statusText + ': Could not remove the creative library item.');
	}

	const data = await response.json();

	return data;
}
